import React from 'react';

interface CheckboxProps {
  className?: string;
}

export const CheckboxSelected: React.FC<CheckboxProps> = ({ className }) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    <rect x="3" y="3" width="18" height="18" fill="white" stroke="#1C1C1C" strokeWidth="2"/>
    <path d="M6 12.8L9.42857 16L18 8" stroke="#1C1C1C" strokeWidth="2"/>
  </svg>
);

export const CheckboxUnselected: React.FC<CheckboxProps> = ({ className }) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    <rect x="3" y="3" width="18" height="18" fill="white" stroke="#1C1C1C" strokeWidth="2"/>
  </svg>
);

// Convenience component that renders the appropriate checkbox based on checked state
interface CustomCheckboxProps extends CheckboxProps {
  checked: boolean;
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, className }) => {
  return checked ? (
    <CheckboxSelected className={className} />
  ) : (
    <CheckboxUnselected className={className} />
  );
}; 